export default __webpack_public_path__ + "static/media/Helm of the Stormbringer.0814ae26.jpg";